import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchInstallationUpdatesStatusResponse } from "./FetchInstallationUpdatesStatusResponse";
import { FetchInstallationsUpdatesStatusServerReqData } from "./FetchInstallationsUpdatesStatusRequestData";

const ENDPOINT = "/device_update";

export class FetchInstallationUpdatesStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsUpdatesStatusServerReqData;

    constructor(payload: FetchInstallationsUpdatesStatusServerReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationUpdatesStatusResponse> {
        var res = await this.executeCommand({ ...this.payload });
        return new FetchInstallationUpdatesStatusResponse(res);
    }
}
